import { render } from "./MTableHeader.vue?vue&type=template&id=22a1d831&scoped=true&ts=true"
import script from "./MTableHeader.vue?vue&type=script&lang=ts"
export * from "./MTableHeader.vue?vue&type=script&lang=ts"

import "./MTableHeader.vue?vue&type=style&index=0&id=22a1d831&lang=scss&scoped=true"

import exportComponent from "/Users/kameyamanaoki/dev/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a1d831"]])

export default __exports__